import {
    GET_MAQUINA_DETALLES, MODIFY_FIELD_DETALLE_MAQUINA, ADD_NEW_MAQUINA
} from '../constants/action_types';

const initialState = { maquinadetalles: {}, isLoading: false, updated: false };

export default function (state = initialState, action) {

    switch (action.type) {

        case GET_MAQUINA_DETALLES:

            return { ...state, isLoading: true };

        case GET_MAQUINA_DETALLES + "_SUCCESS":

            return {
                maquinadetalles: { ...action.payload.data, fechaAlta: new Date().toISOString().slice(0, 10) },
                updated: false,
                isLoading: false
            };


        case MODIFY_FIELD_DETALLE_MAQUINA:

            const field = action.payload[0],
                value = action.payload[1];

            return {
                maquinadetalles: { ...state.maquinadetalles, [field]: value },
                updated: false,
                isLoading: false
            };


        case ADD_NEW_MAQUINA:

            return {
                maquinadetalles: { iModeloMaquina: action.payload.defaultModel, centroId: action.payload.defaultCenter, fechaAlta: new Date().toISOString().slice(0, 10), regInterno: action.payload.regInterno, matricula: action.payload.regInterno },
                updated: false,
                isLoading: false
            };

        default:

            return state;
    };

};